export default __webpack_public_path__ + "static/media/img-05.3537f198.png";